import { render, staticRenderFns } from "./ed-board-task-users.vue?vue&type=template&id=68fe278d&scoped=true&"
import script from "./ed-board-task-users.ts?vue&type=script&lang=ts&"
export * from "./ed-board-task-users.ts?vue&type=script&lang=ts&"
import style0 from "./ed-board-task-users.scss?vue&type=style&index=0&id=68fe278d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe278d",
  null
  
)

export default component.exports